export enum ReportingModeEnum {
    Auto,
    Manual
}